import { graphql } from "../generated";

export const GetCompany = graphql(`
  query GetCompany {
    getCompany {
      ID
      tags {
        color
        description
        id
        name
      }
    }
  }
`);
